import dayjs from 'dayjs'
import { useMemo } from 'react'

import {
  isPlateImagingObservation,
  PlatePage_CulturePlate,
  PlatePage_PlateImagingObservation,
} from '~/api/backend/pages/platePageAPI'
import ConfluenceGraphSidebar, {
  ConfluenceDataset,
} from '~/components/ConfluenceGraphSidebar'

export default function PlateConfluenceGraphSidebar({
  plate,
}: {
  plate: PlatePage_CulturePlate
}) {
  const dataset: ConfluenceDataset = useMemo(
    () => ({
      name: 'Plate Average',
      data: plate.plateObservationHistory
        .filter(isPlateImagingObservation)
        .filter(
          ({ confluences }: PlatePage_PlateImagingObservation) =>
            confluences.length > 0,
        )
        .sort((a, b) =>
          a.timestamp < b.timestamp ? -1 : a.timestamp > b.timestamp ? 1 : 0,
        )
        .map(({ timestamp, confluences }) => ({
          timestamp: dayjs(timestamp),
          confluence:
            confluences.reduce((acc, { value }) => acc + value, 0) / confluences.length,
        })),
    }),
    [plate.plateObservationHistory],
  )

  if (dataset.data.length === 0 || dataset.data.every(d => d.confluence === 0)) {
    return null
  }

  return <ConfluenceGraphSidebar datasets={{ PLATE_AVG: dataset }} lineColor='#666' />
}
